import 'simplebar/src/simplebar.css';
import React from 'react';

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import store from './store';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import CircularProgress from '@mui/material/CircularProgress';

export const getOrRegisterServiceWorker = () => {
  if (
    'serviceWorker' in navigator &&
    typeof window?.navigator?.serviceWorker !== 'undefined'
  ) {
    return window?.navigator?.serviceWorker
      .getRegistration('/firebase-push-notification-scope')
      .then((serviceWorker) => {
        if (serviceWorker) return serviceWorker;
        return window?.navigator?.serviceWorker
          ?.register('/firebase-messaging-sw.js', {
            scope: '/firebase-push-notification-scope',
          })
          .then((registration) => {
            return new Promise((resolve) => {
              if (registration.waiting) {
                resolve(registration);
              } else if (registration.active) {
                resolve(registration);
              } else {
                // Listen for the service worker to activate
                registration.addEventListener('updatefound', () => {
                  const newWorker = registration.installing;
                  newWorker?.addEventListener('statechange', () => {
                    if (newWorker.state === 'activated') {
                      resolve(registration);
                    }
                  });
                });
              }
            });
          });
      });
  }
  throw new Error('The browser doesn`t support service worker.');
};

const container = document.getElementById('root');
// eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <CollapseDrawerProvider>
          <React.Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <CircularProgress
                  sx={{
                    color: '#EE3750',
                  }}
                />
              </div>
            }
          >
            <App />
          </React.Suspense>
        </CollapseDrawerProvider>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
